export default __webpack_public_path__ + "static/media/MobileIron.ef19e875.svg";